import { render } from "./PodAffinity.vue?vue&type=template&id=2120b21b"
import script from "./PodAffinity.vue?vue&type=script&lang=js"
export * from "./PodAffinity.vue?vue&type=script&lang=js"

import "./PodAffinity.vue?vue&type=style&index=0&id=2120b21b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__